import actions from './actions'

const initialState = {
  menuData: [],
  inboxCount: 0,
  
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
      case actions.SET_CONVERSATION_DATA:
        return { conversation_data:  action.payload };
    default:
      return state
  }
}
